var _path, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00042 21.0007H19.0004M11.5624 3.26666C11.6056 3.18826 11.669 3.12289 11.746 3.07736C11.8231 3.03183 11.9109 3.00781 12.0004 3.00781C12.0899 3.00781 12.1778 3.03183 12.2548 3.07736C12.3319 3.12289 12.3953 3.18826 12.4384 3.26666L15.3904 8.87066C15.4608 9.00042 15.5591 9.11299 15.6781 9.20028C15.7972 9.28756 15.9341 9.34741 16.079 9.37552C16.224 9.40362 16.3733 9.39929 16.5164 9.36283C16.6594 9.32638 16.7926 9.2587 16.9064 9.16466L21.1834 5.50066C21.2655 5.43388 21.3667 5.39487 21.4724 5.38926C21.5781 5.38364 21.6828 5.4117 21.7715 5.4694C21.8602 5.5271 21.9284 5.61147 21.9661 5.71035C22.0038 5.80923 22.0092 5.91753 21.9814 6.01966L19.1474 16.2657C19.0896 16.4753 18.9649 16.6604 18.7924 16.7929C18.6199 16.9253 18.4089 16.9979 18.1914 16.9997H5.81042C5.59276 16.9981 5.38153 16.9256 5.20882 16.7932C5.0361 16.6607 4.91132 16.4755 4.85342 16.2657L2.02042 6.02066C1.99267 5.91853 1.99805 5.81023 2.03577 5.71135C2.07348 5.61247 2.14161 5.5281 2.23032 5.4704C2.31904 5.4127 2.42378 5.38464 2.52946 5.39026C2.63515 5.39587 2.73632 5.43488 2.81842 5.50166L7.09442 9.16566C7.20822 9.2597 7.34143 9.32738 7.48449 9.36383C7.62754 9.40029 7.7769 9.40462 7.92182 9.37652C8.06675 9.34841 8.20366 9.28856 8.32272 9.20127C8.44177 9.11399 8.54003 9.00142 8.61042 8.87166L11.5624 3.26666Z",
    stroke: "url(#paint0_linear_448_41465)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 20,
    width: 16,
    height: 2,
    rx: 1,
    fill: "url(#paint1_linear_448_41465)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_41465",
    x1: 2.00293,
    y1: 12.0042,
    x2: 21.9989,
    y2: 12.0042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_448_41465",
    x1: 4,
    y1: 21,
    x2: 20,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.b3e0214cae7ff24a44b726024c5c68d6.svg";
export { ForwardRef as ReactComponent };